import { useMutation } from "react-query"
import reportService from "api/reportService"

const useGetReportWashers = () => {
  return useMutation(async (data: number[]) => {
    const res = await reportService.getReportWashers(data)

    return res.data
  })
}

export default useGetReportWashers
